/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 25b8f70ee793fc9cf259c3863ff80c84 */

import { ConcreteRequest } from "relay-runtime";

export type ApprovalStatus = "ACTIVE" | "ARCHIVED" | "INACTIVE" | "PENDING" | "%future added value";
export type PartnerProgramEnrollmentBillingCycle = "ANNUAL" | "MONTHLY" | "%future added value";
export type PartnerProgramEnrollmentMarket = "CAN_001" | "NA_001" | "%future added value";
export type PartnerProgramEnrollmentStatus = "ACTIVE" | "CANCELLED" | "EXPIRED" | "NOT_STARTED" | "PENDING" | "WITHDRAWN" | "%future added value";
export type HomeQueryVariables = {};
export type HomeQueryResponse = {
    readonly viewer: {
        readonly id: string | null;
        readonly partnerUsers: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly partnerAccount?: {
                        readonly id: string | null;
                        readonly status: ApprovalStatus | null;
                        readonly partnerBrandProfile: {
                            readonly logo: string | null;
                            readonly status: ApprovalStatus | null;
                        } | null;
                        readonly partnerProgramEnrollments: {
                            readonly edges: ReadonlyArray<{
                                readonly node: {
                                    readonly id: string | null;
                                    readonly __typename: string;
                                    readonly partnerProgram: {
                                        readonly name: string | null;
                                    } | null;
                                    readonly status: PartnerProgramEnrollmentStatus | null;
                                    readonly activationDate: string | null;
                                    readonly billingCycle: PartnerProgramEnrollmentBillingCycle | null;
                                    readonly enrollmentMarket: PartnerProgramEnrollmentMarket | null;
                                    readonly purchaseDate: string | null;
                                    readonly cancellationDate: string | null;
                                    readonly cancellationReason: string | null;
                                    readonly autoRenew: boolean | null;
                                    readonly subscriptionEndDate: string | null;
                                    readonly billableQuantity: number | null;
                                    readonly logoApproved?: boolean | null | undefined;
                                };
                            } | null>;
                        } | null;
                    } | null | undefined;
                };
            } | null>;
        } | null;
    } | null;
};
export type HomeQuery = {
    readonly response: HomeQueryResponse;
    readonly variables: HomeQueryVariables;
};



/*
query HomeQuery {
  viewer {
    id
    partnerUsers {
      edges {
        node {
          __typename
          ... on PartnerUser {
            partnerAccount {
              id
              status
              partnerBrandProfile {
                logo
                status
              }
              partnerProgramEnrollments {
                edges {
                  node {
                    id
                    __typename
                    partnerProgram {
                      __typename
                      name
                      id
                    }
                    status
                    activationDate
                    billingCycle
                    enrollmentMarket
                    purchaseDate
                    cancellationDate
                    cancellationReason
                    autoRenew
                    ... on HomeownerAppBrandingPartnerProgramEnrollment {
                      logoApproved
                    }
                    subscriptionEndDate
                    billableQuantity
                  }
                }
              }
            }
          }
          id
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PartnerBrandProfile",
  "kind": "LinkedField",
  "name": "partnerBrandProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logo",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activationDate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingCycle",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enrollmentMarket",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "purchaseDate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancellationDate",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancellationReason",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoRenew",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionEndDate",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billableQuantity",
  "storageKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoApproved",
      "storageKey": null
    }
  ],
  "type": "HomeownerAppBrandingPartnerProgramEnrollment",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CorePartnerUserConnection",
            "kind": "LinkedField",
            "name": "partnerUsers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CorePartnerUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerAccount",
                            "kind": "LinkedField",
                            "name": "partnerAccount",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              (v1/*: any*/),
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PartnerProgramEnrollmentConnection",
                                "kind": "LinkedField",
                                "name": "partnerProgramEnrollments",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PartnerProgramEnrollmentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v0/*: any*/),
                                          (v3/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "partnerProgram",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v1/*: any*/),
                                          (v5/*: any*/),
                                          (v6/*: any*/),
                                          (v7/*: any*/),
                                          (v8/*: any*/),
                                          (v9/*: any*/),
                                          (v10/*: any*/),
                                          (v11/*: any*/),
                                          (v12/*: any*/),
                                          (v13/*: any*/),
                                          (v14/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "PartnerUser",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HomeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CorePartnerUserConnection",
            "kind": "LinkedField",
            "name": "partnerUsers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CorePartnerUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v0/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PartnerAccount",
                            "kind": "LinkedField",
                            "name": "partnerAccount",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              (v1/*: any*/),
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PartnerProgramEnrollmentConnection",
                                "kind": "LinkedField",
                                "name": "partnerProgramEnrollments",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PartnerProgramEnrollmentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v0/*: any*/),
                                          (v3/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "partnerProgram",
                                            "plural": false,
                                            "selections": [
                                              (v3/*: any*/),
                                              (v4/*: any*/),
                                              (v0/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v1/*: any*/),
                                          (v5/*: any*/),
                                          (v6/*: any*/),
                                          (v7/*: any*/),
                                          (v8/*: any*/),
                                          (v9/*: any*/),
                                          (v10/*: any*/),
                                          (v11/*: any*/),
                                          (v12/*: any*/),
                                          (v13/*: any*/),
                                          (v14/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "PartnerUser",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "25b8f70ee793fc9cf259c3863ff80c84",
    "metadata": {},
    "name": "HomeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = '20f04d797a952b9dde73f9fc088d300b';
export default node;
